module.exports = __webpack_public_path__ + "static/media/997745.fff190bc.jpg";